export class RegionUtils {
  static getRegionFlag(region: string): string {
    return region?.toLowerCase() === 'us' ? '🇺🇸' : '🇪🇺';
  }
}
